import { useState } from "react";
import { Tooltip, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import WallpaperIcon from '@material-ui/icons/Wallpaper';
import { APIURL } from "../../../Constantes";
const DialogTipoExtra = (props) => {
    const { TipoExtra, idExtra } = props
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <Tooltip title="Ver descripción">
                <span>
                    <Button
                        variant="text"
                        color="primary"
                        onClick={handleClickOpen}
                    >
                        <WallpaperIcon />
                    </Button>
                </span>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth='md'
            >
                <DialogTitle id="form-dialog-title">Tipo extra</DialogTitle>
                <DialogContent>
                    <div>
                        <div style={{textAlign: "center", padding: "10px 0"}}>
                           <Typography variant="h6">{TipoExtra}</Typography>
                        </div>
                        <div>
                            <img 
                                alt="Extra" 
                                style={{ width: "100%", height: "auto", maxWidth: "1000px" }} 
                                src={`${APIURL}/Addon/Extra/Image/${idExtra}`} 
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default DialogTipoExtra